import reducer from './reducers';
import DeviceLogsContainer from './components/LogsContainer';
import actions from './actions';

export {
  DeviceLogsContainer,
  actions,
};

export default reducer;
